interface Props {
    status: 'green' | 'yellow' | 'red';
    showLabel?: boolean;
}

const STATUS_CONFIG = {
    green: { emoji: '🟢', label: 'Documents present; financial review required', className: 'compliance-green' },
    yellow: { emoji: '🟡', label: 'Supporting document present', className: 'compliance-yellow' },
    red: { emoji: '🔴', label: 'Needs Docs', className: 'compliance-red' },
};

export default function ComplianceIndicator({ status, showLabel = false }: Props) {
    const config = STATUS_CONFIG[status];

    return (
        <span
            className={`compliance-indicator ${config.className}`}
            title={config.label}
            role="img"
            aria-label={config.label}
        >
            {config.emoji}
            {showLabel && <span className="compliance-label">{config.label}</span>}
        </span>
    );
}
